/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';

const useFeatureAccess = () => {
    const [featureAccess, setFeatureAccess] = useState(false);

    useEffect(() => {
        const planDetailsString = sessionStorage.getItem('PLAN_DETAILS');
        const planDetails = planDetailsString ? JSON.parse(planDetailsString) : [];
        const retrievedPlanName = planDetails[0]?.planName;
        if (retrievedPlanName && retrievedPlanName !== 'Silver') {
            setFeatureAccess(true);
        }
        else {
            setFeatureAccess(false);
        }
    }, [sessionStorage.getItem('PLAN_DETAILS')]);

    return featureAccess;
};

export default useFeatureAccess;
